import { ApiBase } from '@fg-services/api/models/api-base';
import { Observable } from 'rxjs';

interface AnalyticsData {
  totalOrganizations: number;
  totalWhiteLabelOrganizations: number;
  totalWhiteLabelConventions: number;
  whiteLabelOrganizations: Array<{
    orgId: string;
    orgName: string;
  }>;
}

interface ConventionData {
  id: string;
  name: string;
  // Add other convention fields as needed
}

interface ConventionAnalytics {
  attendeeCount: number;
  voteCount: number;
  voteCountPercentage: number;
  postCount: number;
  postCountPercentage: number;
  contestEntryCount: number;
  contestEntryCountPercentage: number;
  eventAttendeeCount: number;
  eventAttendeeCountPercentage: number;
  eventRatingCount: number;
  eventRatingCountPercentage: number;
  celebrityRatingCount: number;
  celebrityRatingCountPercentage: number;
  exhibitorRatingCount: number;
  exhibitorRatingCountPercentage: number;
  surveyResponseCount: number;
  surveyResponseCountPercentage: number;
}

interface OrgAnalytics {
  totalCelebrities: number;
  totalConventionAttendees: number;
  totalConventions: number;
  totalExibitors: number;
  totalOrganizations: number;
}

export class AnalyticsApi extends ApiBase {
  model = 'Organizations';

  postAnalytics(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiBase}/Analytics`, payload);
  }

  getAnalytics(orgId: string): Observable<any> {
    return this.http.get<any>(`${this.apiBase}/Analytics/${orgId}/AnalyticsMapping`);
  }

  getWhiteLabelOrgAnalytics(): Observable<AnalyticsData> {
    return this.http.get<AnalyticsData>(`${this.modelBase}/whiteLabelOrgAnalytics`);
  }

  getOrgAnalytics(): Observable<OrgAnalytics> {
    return this.http.get<OrgAnalytics>(`${this.modelBase}/orgAnalytics`);
  }

  getConventions(orgId: string): Observable<ConventionData[]> {
    return this.http.get<ConventionData[]>(`${this.modelBase}/${orgId}/Conventions`);
  }

  getConventionFandomData(conventionId: string): Observable<ConventionData[]> {
    return this.http.get<ConventionData[]>(`${this.modelBase}/Conventions/${conventionId}/data`, {
      params: this.setParams({ type: 'fandom' })
    });
  }

  getConventionAnalytics(conventionId: string): Observable<ConventionAnalytics> {
    return this.http.get<ConventionAnalytics>(`${this.modelBase}/Conventions/${conventionId}/data`, {
      params: this.setParams({ type: 'percentage' })
    });
  }
}
